/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360NfcStickersModelsNfcSticker {
    PlaceID?: number;
    PlaceName?: string;
    PlaceArchived?: boolean;
    Position?: string;
    EntityID?: string;
    EntityName?: string;
    EntityImageToken?: string;
    /**
     * 1 = Product, 2 = InformationCard, 3 = Offer, 4 = CheckOut, 5 = CheckIn
     */
    NfcStickerType?: Open360NfcStickersModelsNfcSticker.NfcStickerTypeEnum;
    Deleted?: boolean;
    ID?: string;
    AssignedDate?: Date;
}
export namespace Open360NfcStickersModelsNfcSticker {
    export type NfcStickerTypeEnum = 1 | 2 | 3 | 4 | 5;
    export const NfcStickerTypeEnum = {
        Product: 1 as NfcStickerTypeEnum,
        InformationCard: 2 as NfcStickerTypeEnum,
        Offer: 3 as NfcStickerTypeEnum,
        CheckOut: 4 as NfcStickerTypeEnum,
        CheckIn: 5 as NfcStickerTypeEnum
    };
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360NfcStickersModelsNfcSticker.ts